// ============================================================================
// Engage browser location
// ============================================================================
// Asks the visitor for their browser (HTML5 geolocation) position and stores
// it in a cookie. Server-side, the Umbraco Engage "Browser location" segment
// rule (Vebego.Code/Modules/Engage/BrowserLocation) reads this cookie on every
// pageview to determine whether the visitor falls within a segment's radius.
//
// This is NOT a functional cookie: it falls in Cookiebot's "preferences"
// category, the same category that gates Engage personalization server-side
// (see CookieBotModulePermissions). Without that consent nothing happens: no
// geolocation prompt, no cookie, and any previously stored location cookie is
// removed. Without personalization consent Engage skips personalization
// anyway, so the segment simply never matches.
//
// Exception: local environments (*.127.0.0.1.nip.io, see launchSettings.json
// in Vebego.Web) don't load Cookiebot at all. There the location is fetched
// without consent check so the feature stays testable, mirroring the
// Development bypass in CookieBotModulePermissions.

(function () {
    'use strict';

    // Must match BrowserLocationSegmentRule.CookieName in Vebego.Code
    var COOKIE_NAME = 'vebegoBrowserLocation';
    var COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60;

    function hasLocationCookie() {
        return document.cookie.split('; ').some(function (cookie) {
            return cookie.indexOf(COOKIE_NAME + '=') === 0;
        });
    }

    function deleteLocationCookie() {
        document.cookie = COOKIE_NAME + '=; max-age=0; path=/';
    }

    function storeLocation(position) {
        // Rounded to 3 decimals (~100m): precise enough for radius
        // segmentation without storing the visitor's exact position
        var latitude = position.coords.latitude.toFixed(3);
        var longitude = position.coords.longitude.toFixed(3);

        // "|" (not ",") because a raw comma in a cookie value is outside RFC 6265's
        // cookie-octet grammar: ASP.NET Core's Request.Cookies parser silently drops
        // the whole cookie when it sees one, even though browsers accept it fine.
        document.cookie = COOKIE_NAME + '=' + latitude + '|' + longitude +
            '; max-age=' + COOKIE_MAX_AGE_SECONDS +
            '; path=/; SameSite=Lax' +
            (window.location.protocol === 'https:' ? '; Secure' : '');
    }

    function fetchLocation() {
        if (hasLocationCookie() || !('geolocation' in navigator)) {
            return;
        }

        navigator.geolocation.getCurrentPosition(
            storeLocation,
            function () {
                // Denied or unavailable: no cookie is set and the visitor
                // simply won't match any browser location segment
            },
            {
                maximumAge: 15 * 60 * 1000,
                timeout: 10000
            }
        );
    }

    function preferencesConsentGiven() {
        return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences);
    }

    function isLocalEnvironment() {
        var hostname = window.location.hostname;
        return hostname === 'localhost'
            || hostname === '127.0.0.1'
            || hostname.endsWith('.127.0.0.1.nip.io');
    }

    function applyConsentState() {
        if (preferencesConsentGiven()) {
            fetchLocation();
        } else if (hasLocationCookie()) {
            // Consent withdrawn or declined: clean up our cookie
            deleteLocationCookie();
        }
    }

    // Fires once Cookiebot knows the visitor's consent state (on every page
    // load, and again when the visitor accepts, declines, or changes consent).
    // If Cookiebot never loads, nothing happens at all (except locally).
    window.addEventListener('CookiebotOnConsentReady', applyConsentState);

    // Cookiebot may already be initialized before this script runs
    if (window.Cookiebot && window.Cookiebot.consent) {
        applyConsentState();
    }

    // Local environments don't load Cookiebot: fetch the location anyway so
    // the segment can be tested. Cookiebot still gets a moment to initialize
    // in case it is configured locally (Engage:IsTest), and wins if it does.
    if (isLocalEnvironment()) {
        var fetchWithoutCookiebot = function () {
            setTimeout(function () {
                if (!window.Cookiebot) {
                    fetchLocation();
                }
            }, 1000);
        };

        if (document.readyState === 'complete') {
            fetchWithoutCookiebot();
        } else {
            window.addEventListener('load', fetchWithoutCookiebot);
        }
    }
})();
